<template>
    <div>
        <header>
            <div class="banner">
                <van-row>
                    <van-col span="6" @click="back"><img class="back-icon"
                                                         :src="require(`@/assets/theme/${theme}/status/01dailyActive/01back.svg`)">
                    </van-col>
                    <van-col span="12">
                        <div class="banner-title">{{ $t('timeLine.title') }}</div>
                    </van-col>
                </van-row>
            </div>
        </header>
        <div class="content">
            <div class="time-box">
                <div class="time-item" :class="{'time-active': activeType === 0}" @click="changeType(0)">
                    {{ $t('timeLine.hr') }}
                </div>
                <div class="time-item" :class="{'time-active': activeType === 1}" @click="changeType(1)">
                    {{ $t('timeLine.pressure') }}
                </div>
            </div>
            <div class="time-select">
                <img @click="timeLeft" class="time-icon" :class="{'arr-opacity' : showLeftOpacity == 1}"
                     :src="require(`@/assets/theme/${theme}/status/01dailyActive/03left.svg`)">
                <div class="time-date">{{ time }}</div>
                <img @click="timeRight" class="time-icon" :class="{'arr-opacity' : showRightOpacity == 1}"
                     :src="require(`@/assets/theme/${theme}/status/01dailyActive/04right.svg`)">
                <div class="chart-unit" v-if="mathData.avgData">{{ $t('hr.unit') }}</div>
            </div>
            <div class="data-box">
                <div class="avg-box">
                    <div class="math-title">{{ $t('timeLine.avg') }}</div>
                    <div class="math-value">87
                        <sapn class="math-unit">bpm</sapn>
                    </div>
                </div>
                <div class="avg-box rang-box">
                    <div class="math-title">{{ $t('timeLine.avg') }}</div>
                    <div class="math-value">56 - 125
                        <sapn class="math-unit">bpm</sapn>
                    </div>
                </div>
            </div>
            <div class="chart-out">
                <div class="chart-unit" v-if="activeType == 0">bpm</div>
                <div class="chart-box" id="chart-box-hr" v-show="activeType == 0"></div>
                <div class="chart-box" id="chart-box-pressure" v-show="activeType == 1"></div>
                <div v-if="activeType == 1" id="y-axis-lines">
                    <div style="height: 25%; background-color: var(--chart-color-3);"></div>
                    <div style="height: 25%; background-color: var(--chart-color-5);"></div>
                    <div style="height: 25%; background-color: var(--chart-color-13);"></div>
                    <div style="height: 25%; background-color: var(--chart-color-8);"></div>
                </div>
            </div>
            <div class="line-box">
                <img class="line-img" src="@/assets/theme/light/sport/04sportDesc/18游泳.png">
                <div class="line-time">20:40-20:50</div>
                <div class="line-type">SPO2</div>
                <div class="line-value-box">
                    247<span class="line-unit">kcal</span>
                </div>
                <div class="line-split"></div>
                <div class="line-hr-title1">AVG</div>
                <div class="line-hr-value1">135<span class="line-unit">bpm</span></div>
                <div class="line-hr-title2">RANG</div>
                <div class="line-hr-value2">92-168<span class="line-unit">bpm</span></div>
            </div>
            <div class="line-box">
                <img class="line-img" src="@/assets/theme/light/sport/04sportDesc/18游泳.png">
                <div class="line-time">20:40-20:50</div>
                <div class="line-type">SPO2</div>
                <div class="line-value-box">
                    247<span class="line-unit">kcal</span>
                </div>
                <div class="line-split"></div>
                <div class="line-hr-title1">AVG</div>
                <div class="line-hr-value1">135<span class="line-unit">bpm</span></div>
                <div class="line-hr-title2">RANG</div>
                <div class="line-hr-value2">92-168<span class="line-unit">bpm</span></div>
            </div>
        </div>
    </div>
</template>

<script>
import {getQueryVariable, getSkin} from '@/utils/comment'
import {
    getToday,
    getNWeekFirstDay,
    getNWeekLastDay,
    getMonthStartDay,
    getMonthEndDay,
    GetDateStr, SwitchTime24,
    changeDate,
    changeMonthDate,
    GetYear
} from "../../utils/dateUtils";
import {WebJSBridge} from "../../utils/JSBridge1";

export default {
    name: 'myHr',
    data() {
        return {
            ratio: 1,
            theme: getQueryVariable("theme") ? getQueryVariable("theme") : "light",
            activeTime: 0,
            timeUnit: '',
            time: '',
            startDate: '',
            endDate: '',
            tNum: 0,
            wNum: 0,
            mNum: 0,
            yNum: 0,
            showTimeBox: false,
            hrInfo: {},
            mathData: {},
            ecgInfo: {},
            myChart: null,
            pressureChart: null,
            showLeftOpacity: 0,
            showRightOpacity: 1,
            activeType: 0,
        }
    },
    watch: {
        showTimeBox: {
            handler(newVal, olVal) {
                if (newVal) {
                    setTimeout(() => {
                        document.addEventListener('click', this.checkClick);
                    }, 0);
                } else {
                    document.removeEventListener('click', this.checkClick);
                }
            }
        }
    },
    mounted() {
        this.ratio = document.body.clientWidth / 375 ? document.body.clientWidth / 375 : 1;
        this.timeUnit = this.$t('hr.time0');
        this.startDate = getToday();
        this.endDate = getToday();
        this.time = getToday().slice(5, 10).replace(/-/g, '/');
        this.getData();
    },
    methods: {
        back() {
            WebJSBridge.call("closeWeb", null, function (res) {
            });
        },
        checkClick(event) {
            let dom = this.$refs.showContent; // 这里是你的下拉菜单元素
            if (!dom.contains(event.target)) {
                // 不在菜单范围，隐藏即可
                if (this.showTimeBox) {
                    this.showTimeBox = false;
                    document.removeEventListener('click', this.checkClick);
                }
            }
        },
        checkOpacity() {
            if (this.activeTime == 0 && this.tNum <= 0) {
                this.showRightOpacity = 1
            } else if (this.activeTime == 1 && this.wNum >= 0) {
                this.showRightOpacity = 1
            } else if (this.activeTime == 2 && this.mNum >= 0) {
                this.showRightOpacity = 1
            } else if (this.activeTime == 3 && this.yNum >= 0) {
                this.showRightOpacity = 1
            } else {
                this.showRightOpacity = 0
            }
            if (this.activeTime == 0 && this.startDate <= '2020-01-01') {
                this.showLeftOpacity = 1
            } else if (this.activeTime == 1 && this.startDate <= '2020-01-01') {
                this.showLeftOpacity = 1
            } else if (this.activeTime == 2 && this.startDate <= '2020-01-01') {
                this.showLeftOpacity = 1
            } else if (this.activeTime == 3 && GetYear(this.yNum - 1) <= 2019) {
                this.showLeftOpacity = 1
            } else {
                this.showLeftOpacity = 0
            }
        },
        timeLeft() {
            if (this.activeTime == 0 && this.startDate > '2020-01-01') {
                this.tNum++;
                this.startDate = GetDateStr(this.tNum);
                this.endDate = GetDateStr(this.tNum);
                this.time = this.startDate.slice(5, 10).replace(/-/g, '/');
            } else if (this.activeTime == 1 && this.startDate > '2020-01-01') {
                this.wNum--;
                this.startDate = getNWeekFirstDay(this.wNum);
                this.endDate = getNWeekLastDay(this.wNum);
                this.time = this.startDate.slice(5, 10).replace(/-/g, '/') + ' - ' + this.endDate.slice(5, 10).replace(/-/g, '/');
            } else if (this.activeTime == 2 && this.startDate > '2020-01-01') {
                this.mNum--;
                this.startDate = getMonthStartDay(this.mNum);
                this.endDate = getMonthEndDay(this.mNum);
                this.time = changeMonthDate(this.startDate);
            } else if (this.activeTime == 3 && GetYear(this.yNum - 1) > 2019) {
                this.yNum--;
                this.startDate = GetYear(this.yNum);
                this.time = GetYear(this.yNum);
            }
            this.getData();
            this.checkOpacity();
        },
        timeRight() {
            if (this.activeTime == 0 && this.tNum > 0) {
                this.tNum--;
                this.startDate = GetDateStr(this.tNum);
                this.endDate = GetDateStr(this.tNum);
                this.time = this.startDate.slice(5, 10).replace(/-/g, '/');
            } else if (this.activeTime == 1 && this.wNum < 0) {
                this.wNum++;
                this.startDate = getNWeekFirstDay(this.wNum);
                this.endDate = getNWeekLastDay(this.wNum);
                this.time = this.startDate.slice(5, 10).replace(/-/g, '/') + ' - ' + this.endDate.slice(5, 10).replace(/-/g, '/');
            } else if (this.activeTime == 2 && this.mNum < 0) {
                this.mNum++;
                this.startDate = getMonthStartDay(this.mNum);
                this.endDate = getMonthEndDay(this.mNum);
                this.time = changeMonthDate(this.startDate);
            } else if (this.activeTime == 3 && this.yNum < 0) {
                this.yNum++;
                this.startDate = GetYear(this.yNum);
                this.time = GetYear(this.yNum);
            }
            this.getData();
            this.checkOpacity();
        },
        changeType(num) {
            this.activeType = num;
            this.$nextTick(function () {
                // 销毁不需要的图表实例
                if (num === 0 && this.pressureChart) {
                    this.pressureChart.dispose();
                    this.pressureChart = null;
                } else if (num === 1 && this.myChart) {
                    this.myChart.dispose();
                    this.myChart = null;
                }
                this.drawDayChart()
                this.$forceUpdate()
            })
        },
        changeTimeType(num, unit) {
            this.activeTime = num;
            this.timeUnit = unit;
            this.showTimeBox = false;
            if (this.activeTime == 1) {
                this.startDate = getNWeekFirstDay(this.wNum);
                this.endDate = getNWeekLastDay(this.wNum);
                this.time = this.startDate.slice(5, 10).replace(/-/g, '/') + ' - ' + this.endDate.slice(5, 10).replace(/-/g, '/');
            }
            if (this.activeTime == 2) {
                this.startDate = getMonthStartDay(this.mNum);
                this.endDate = getMonthEndDay(this.mNum);
                this.time = changeMonthDate(this.startDate);
            }
            if (this.activeTime == 0) {
                this.startDate = GetDateStr(this.tNum);
                this.endDate = GetDateStr(this.tNum);
                this.time = this.startDate.slice(5, 10).replace(/-/g, '/');
            }
            if (this.activeTime == 3) {
                this.startDate = GetYear(this.yNum);
                this.time = GetYear(this.yNum);
            }
            this.getData();
            this.checkOpacity();
        },
        getData() {
            this.mathData = {}
            if (this.activeTime == 0) {
                this.$api.status.getHr({
                    type: 'heartRate',
                    date: this.startDate
                }).then(res => {
                    if (res.result == 1) {
                        if (res.info[0]) {
                            this.mathData.maxData = res.info[0].hrMax;
                            this.mathData.avgData = res.info[0].hrAvg;
                            this.mathData.minData = res.info[0].hrMin;
                            this.mathData.basicData = res.info[0].hrBasic;
                            this.hrInfo = res.info[0];
                        } else {
                            this.mathData.maxData = 0;
                            this.mathData.avgData = 0;
                            this.mathData.minData = 0;
                            this.mathData.basicData = 0;
                        }
                        this.$nextTick(function () {
                            this.drawDayChart()
                            this.$forceUpdate()
                        })
                    }
                })
            } else if (this.activeTime == 3) {
                let hrInfo;
                this.$api.status.queryHrDataByYear({
                    year: this.startDate,
                }).then(res => {
                    if (res.result == 1) {
                        this.mathData.maxData = res.info.max;
                        this.mathData.avgData = res.info.avg;
                        this.mathData.minData = res.info.min;
                        this.mathData.basicData = res.info.basicHrAvg;
                        hrInfo = res.info;
                        this.hrInfo.dateArr = [];
                        this.hrInfo.dataMinArr = [];
                        this.hrInfo.dataMaxArr = [];
                        this.hrInfo.dataBasicArr = [];
                        for (let i = 0; i < hrInfo.hr.length; i++) {
                            this.hrInfo.dateArr.push(i + 1);
                            this.hrInfo.dataMinArr.push(hrInfo.hr[i].hrMin);
                            if (hrInfo.hr[i].hrMax == hrInfo.hr[i].hrMin && hrInfo.hr[i].hrMax > 0) {
                                this.hrInfo.dataMaxArr.push(0.9);
                            } else {
                                this.hrInfo.dataMaxArr.push(hrInfo.hr[i].hrMax - hrInfo.hr[i].hrMin);
                            }

                            this.hrInfo.dataBasicArr.push(hrInfo.hr[i].basicHrAvg);
                        }
                        this.$nextTick(function () {
                            this.drawChart()
                            this.$forceUpdate()
                        })
                    }
                })
            } else {
                let hrInfo;
                this.$api.status.getHr({
                    type: 'heartRate',
                    startDate: this.startDate,
                    endDate: this.endDate
                }).then(res => {
                    if (res.result == 1) {
                        this.mathData.maxData = res.info.maxHr;
                        this.mathData.avgData = res.info.avgHr;
                        this.mathData.minData = res.info.minHr;
                        this.mathData.basicData = res.info.avgBasicHr;
                        hrInfo = res.info;
                        this.hrInfo.dateArr = [];
                        this.hrInfo.dataMinArr = [];
                        this.hrInfo.dataMaxArr = [];
                        this.hrInfo.dataBasicArr = [];
                        for (let i = 0; i < hrInfo.dataHr.length; i++) {
                            this.hrInfo.dateArr.push(changeDate(hrInfo.dataHr[i].date));
                            this.hrInfo.dataMinArr.push(hrInfo.dataHr[i].hrMin);
                            if (hrInfo.dataHr[i].hrMax == hrInfo.dataHr[i].hrMin && hrInfo.dataHr[i].hrMax > 0) {
                                this.hrInfo.dataMaxArr.push(0.9);
                            } else {
                                this.hrInfo.dataMaxArr.push(hrInfo.dataHr[i].hrMax - hrInfo.dataHr[i].hrMin);
                            }
                            this.hrInfo.dataBasicArr.push(hrInfo.dataHr[i].hrBasic);
                        }
                        this.$nextTick(function () {
                            this.drawChart()
                            this.$forceUpdate()
                        })
                    }
                })
            }
        },
        getColorByValue(value) {
            if (value <= 29) return getSkin('--chart-color-8');
            if (value <= 59) return getSkin('--chart-color-13');
            if (value <= 79) return getSkin('--chart-color-5');
            return getSkin('--chart-color-3');
        },
        mapValueToPosition(value) {
            const mappingPoints = [
                {value: 0, position: 0},     // 0 对应位置 0
                {value: 29, position: 25},   // 29 对应位置 25
                {value: 59, position: 50},   // 59 对应位置 50
                {value: 79, position: 75},   // 79 对应位置 75
                {value: 100, position: 100}  // 100 对应位置 100
            ];

            // 边界处理
            if (value <= 0) return 0;
            if (value >= 100) return 100;

            // 找到 value 所在的区间
            for (let i = 0; i < mappingPoints.length - 1; i++) {
                const p1 = mappingPoints[i];
                const p2 = mappingPoints[i + 1];

                if (value >= p1.value && value <= p2.value) {
                    // 线性插值
                    const ratio = (value - p1.value) / (p2.value - p1.value);
                    return p1.position + ratio * (p2.position - p1.position);
                }
            }

            return value;
        },
        drawDayChart() {
            if (this.activeType) {
                if (!this.pressureChart) {
                    this.pressureChart = this.$echarts.init(document.getElementById("chart-box-pressure"));
                }
                let _this = this;
                const dataList = '29,59,79,100,5,5,15,21,23,9,12,10,12,5,5,5,5,5,6,5,5,12,8,6,7,6,5,6,5,11,14,12,15,8,12,12,8,14,19,22,8,12,12,13,13,12,16,17,20,42,35,24,21,20,16,16,19,22,30,50,62,41,48'.split(',').map(Number);
                const maxVal = Math.max(...dataList);
                const minVal = Math.min(...dataList);
                const maxColor = this.getColorByValue(maxVal);
                const minColor = this.getColorByValue(minVal);
                // 转换数据
                const mappedData = dataList.map(this.mapValueToPosition);
                // 计算映射后的位置
                let maxIndex = dataList.indexOf(maxVal);
                let minIndex = dataList.indexOf(minVal);
                const maxMappedPosition = this.mapValueToPosition(maxVal);
                const minMappedPosition = this.mapValueToPosition(minVal);
                this.pressureChart.setOption({
                    grid: {
                        top: 35 * this.ratio,
                        bottom: 37 * this.ratio,
                        left: 41 * this.ratio,
                        right: 22 * this.ratio
                    },
                    dataZoom: { // 放大和缩放
                        type: 'inside'
                    },
                    tooltip: {
                        backgroundColor: getSkin('--bg-color-2'),
                        trigger: 'axis',
                        position: (point, params, dom, rect, size) => {
                            let x = point[0] - size.contentSize[0] / 2;
                            let cWidth = 375 * _this.ratio;
                            if (x < 0) {
                                x = 0;
                            } else if ((x + size.contentSize[0]) > cWidth) {
                                x = cWidth - size.contentSize[0];
                            }
                            return [x, '0%'];
                        },
                        formatter: function (params, ticket, callback) {
                            let item = params[0];
                            let value = item.data ? dataList[item.dataIndex] : 0;
                            if (value == 0) {
                                return
                            }
                            let html = '';
                            html += '<div style="font-family:D-D;font-size:13px;color: ' + getSkin('--text-color-3') + '">' + item.axisValue + '</div>'
                            html += '<div style="font-family:D-D;font-size:13px;color: ' + getSkin('--text-color-3') + '"><span style="font-size:20px;color: ' + getSkin('--text-color-1') + '">' + value + '</span></div>'
                            return html
                        }
                    },
                    xAxis: {
                        type: 'category',
                        axisLine: {
                            lineStyle: {
                                color: getSkin('--line-color-2')
                            }
                        },
                        axisLabel: {
                            fontSize: 11 * this.ratio,
                            fontFamily: 'D-D',
                            color: getSkin('--text-color-3'),
                            interval: 35
                        },
                        axisTick: {
                            show: false
                        },
                        data: ['00:00', '00:10', '00:20', '00:30', '00:40', '00:50', '01:00', '01:10', '01:20', '01:30', '01:40', '01:50', '02:00', '02:10', '02:20', '02:30', '02:40', '02:50', '03:00', '03:10', '03:20', '03:30', '03:40', '03:50', '04:00', '04:10', '04:20', '04:30', '04:40', '04:50', '05:00', '05:10', '05:20', '05:30', '05:40', '05:50', '06:00', '06:10', '06:20', '06:30', '06:40', '06:50', '07:00', '07:10', '07:20', '07:30', '07:40', '07:50', '08:00', '08:10', '08:20', '08:30', '08:40', '08:50', '09:00', '09:10', '09:20', '09:30', '09:40', '09:50', '10:00', '10:10', '10:20', '10:30', '10:40', '10:50', '11:00', '11:10', '11:20', '11:30', '11:40', '11:50', '12:00', '12:10', '12:20', '12:30', '12:40', '12:50', '13:00', '13:10', '13:20', '13:30', '13:40', '13:50', '14:00', '14:10', '14:20', '14:30', '14:40', '14:50', '15:00', '15:10', '15:20', '15:30', '15:40', '15:50', '16:00', '16:10', '16:20', '16:30', '16:40', '16:50', '17:00', '17:10', '17:20', '17:30', '17:40', '17:50', '18:00', '18:10', '18:20', '18:30', '18:40', '18:50', '19:00', '19:10', '19:20', '19:30', '19:40', '19:50', '20:00', '20:10', '20:20', '20:30', '20:40', '20:50', '21:00', '21:10', '21:20', '21:30', '21:40', '21:50', '22:00', '22:10', '22:20', '22:30', '22:40', '22:50', '23:00', '23:10', '23:20', '23:30', '23:40', '23:50', '24:00']
                    },
                    yAxis: {
                        type: 'value',
                        position: 'left',
                        min: 0,
                        max: 100,
                        splitNumber: 4,
                        interval: 25,
                        axisLabel: {
                            fontSize: 11 * this.ratio,
                            fontFamily: 'D-D',
                            showMinLabel: false,
                            rich: {
                                color29: {
                                    color: getSkin('--chart-color-8')  // 29 的颜色
                                },
                                color59: {
                                    color: getSkin('--chart-color-13')   // 59 的颜色
                                },
                                color79: {
                                    color: getSkin('--chart-color-5')   // 79 的颜色
                                },
                                color100: {
                                    color: getSkin('--chart-color-3')   // 100 的颜色
                                }
                            },
                            formatter: function (value) {
                                if (Math.abs(value - 25) < 0.1) {
                                    return '{color29|29}';
                                }
                                if (Math.abs(value - 50) < 0.1) {
                                    return '{color59|59}';
                                }
                                if (Math.abs(value - 75) < 0.1) {
                                    return '{color79|79}';
                                }
                                if (Math.abs(value - 100) < 0.1) {
                                    return '{color100|100}';
                                }
                                return '';
                            }
                        },
                        splitLine: {
                            lineStyle: {
                                type: 'dotted',
                                color: getSkin('--line-color-3')
                            }
                        },
                    },
                    visualMap: {
                        show: false,
                        pieces: [
                            {
                                gt: 0,
                                lte: 25,
                                color: getSkin('--chart-color-8')
                            }, {
                                gt: 25,
                                lte: 50,
                                color: getSkin('--chart-color-13')
                            },
                            {
                                gt: 50,
                                lte: 75,
                                color: getSkin('--chart-color-5')
                            },
                            {
                                gt: 75,
                                lte: 100,
                                color: getSkin('--chart-color-3')
                            }
                        ]
                    },
                    series: [
                        {
                            data: mappedData,
                            type: 'line',
                            showSymbol: false,
                            color: getSkin('--chart-color-3'),
                            smooth: true,
                            markPoint: {
                                symbol: 'circle',
                                symbolSize: 7,
                                itemStyle: {
                                    borderColor: '#fff',
                                    borderWidth: 2
                                },
                                data: [
                                    // 最大值：标签在上
                                    {
                                        coord: [maxIndex, maxMappedPosition],
                                        name: 'Max',
                                        itemStyle: {color: maxColor},
                                        value: maxVal,
                                        label: {
                                            show: true,
                                            position: 'top',
                                            backgroundColor: maxColor,
                                            color: '#fff',
                                            fontSize: 13 * this.ratio,
                                            padding: [4, 4, 2, 4],
                                            borderRadius: 4
                                        }
                                    },
                                    // 最小值：标签在下
                                    {
                                        coord: [minIndex, minMappedPosition],
                                        name: 'Min',
                                        value: minVal,
                                        itemStyle: {color: minColor},
                                        label: {
                                            show: true,
                                            position: 'bottom',
                                            backgroundColor: minColor,
                                            color: '#fff',
                                            fontSize: 13 * this.ratio,
                                            padding: [4, 4, 2, 4],
                                            borderRadius: 4
                                        }
                                    }
                                ]
                            },
                            markArea: {
                                itemStyle: {opacity: 1},
                                data: [
                                    // 睡眠 00:00-08:00 【垂直从上到下渐变浅】
                                    [{
                                        xAxis: '00:00',
                                        itemStyle: {
                                            color: this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                                {offset: 0, color: getSkin('--text-color-52')},
                                                {offset: 1, color: getSkin('--bg-color-20')}
                                            ])
                                        }
                                    }, {xAxis: '08:00'}],
                                    // 跑步 12:00-13:00 垂直渐变
                                    [{
                                        xAxis: '12:00',
                                        itemStyle: {
                                            color: this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                                {offset: 0, color: getSkin('--text-color-52')},
                                                {offset: 1, color: getSkin('--bg-color-20')}
                                            ])
                                        }
                                    }, {xAxis: '13:00'}]
                                ]
                            }
                        },
                        {
                            type: 'line',
                            data: [],
                            markPoint: {
                                symbolSize: 16 * this.ratio,
                                symbolOffset: [0, '-60%'],
                                label: {show: true, position: 'bottom', color: '#ccc', fontSize: 11},
                                data: [
                                    {
                                        name: '睡眠',
                                        xAxis: '04:00',
                                        yAxis: 100,
                                        symbol: `image://data:image/svg+xml;base64,${btoa('<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><defs><style>.a,.c{fill:none;}.a{opacity:0.16;}.b{fill:#22ACFB;}.c{stroke:#22ACFB;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}</style></defs><g transform="translate(-38 -508)"><rect class="a" width="16" height="16" transform="translate(38 508)"/><g transform="translate(40.018 509.847)"><path class="b" d="M6.153,12.306A6.153,6.153,0,0,1,6.153,0c.181,0,.363.008.542.024A5.594,5.594,0,0,0,11.188,8.95c.151,0,.3-.006.457-.019A6.129,6.129,0,0,1,6.153,12.306Z"/><path class="c" d="M47.734,514.658h3.091l-2.932,3.665h3.182" transform="translate(-39.11 -514.332)"/></g></g></svg>')}`
                                    },
                                    {
                                        name: '跑步',
                                        xAxis: '12:30',
                                        yAxis: 100,
                                        symbol: `image://data:image/svg+xml;base64,${btoa('<svg xmlns="http://www.w3.org/2000/svg" fill="#81f1b1" viewBox="0 0 24 24"><path d="M13.5 5.5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM9.8 8.9L7 23h2.1l1.8-8 2.1 2v6h2v-7.5l-2.1-2 .6-3C14.8 12 16.8 13 19 13v-2c-1.9 0-3.5-1-4.3-2.4l-1-1.6c-.4-.6-1-1-1.7-1-.3 0-.5.1-.8.1L6 8.3V13h2V9.6l1.8-.7"/></svg>')}`
                                    },
                                ]
                            },
                        },
                        {
                            type: 'custom',
                            renderItem: function (params, api) {
                                // 调试：检查是否执行
                                console.log('custom renderItem executed');

                                // 获取 Y 轴的实际位置 - 关键修复
                                // 先获取坐标系的宽度和位置
                                const gridLeft = 41 * _this.ratio; // 和 grid.left 保持一致

                                // 方法1：直接使用 grid.left 的值，并微调位置
                                const x = gridLeft - 10; // 向左偏移，让线条在 Y 轴左侧边缘

                                // 也可以尝试使用 api 获取坐标轴位置
                                // 获取第一个 category 的坐标
                                const firstCategoryCoord = api.coord(['00:00', 0]);
                                console.log('firstCategoryCoord:', firstCategoryCoord);

                                // 获取 Y 轴坐标
                                const y0 = api.coord(['00:00', 0])[1];
                                const y25 = api.coord(['00:00', 25])[1];
                                const y50 = api.coord(['00:00', 50])[1];
                                const y75 = api.coord(['00:00', 75])[1];
                                const y100 = api.coord(['00:00', 100])[1];

                                console.log('y coordinates:', {y0, y25, y50, y75, y100});

                                // 如果坐标都是 null 或 undefined，说明 api.coord 调用方式有问题
                                if (y0 === undefined || y0 === null) {
                                    console.error('api.coord failed, check parameters');
                                    return null;
                                }

                                const segments = [
                                    {start: 0, end: 25, color: '#ff6b6b'},
                                    {start: 25, end: 50, color: '#4ecdc4'},
                                    {start: 50, end: 75, color: '#ffe66d'},
                                    {start: 75, end: 100, color: '#95e77e'}
                                ];

                                const lines = [];

                                for (let seg of segments) {
                                    const yStart = api.coord(['00:00', seg.start])[1];
                                    const yEnd = api.coord(['00:00', seg.end])[1];

                                    lines.push({
                                        type: 'line',
                                        shape: {
                                            x1: x, y1: yStart,
                                            x2: x, y2: yEnd
                                        },
                                        style: {
                                            stroke: seg.color,
                                            lineWidth: 2
                                        }
                                    });
                                }

                                return {
                                    type: 'group',
                                    children: lines
                                };
                            },
                            data: [],
                            silent: true,
                            z: 10,
                            yAxisIndex: 0,
                            xAxisIndex: 0
                        }
                    ]
                }, true);
            } else {
                if (!this.myChart) {
                    this.myChart = this.$echarts.init(document.getElementById("chart-box-hr"));
                }
                const heartData = [
                    68, 65, 63, 61, 59, 58, 57, 56, 56, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 63, 62, 61, 60, 59, 58, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 74, 73, 72, 71, 70,
                    72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 82, 81, 80, 79, 78, 77, 76, 75, 76, 77, 78, 85, 90, 95, 100, 110, 120, 115, 105, 95, 85, 80, 78, 77, 76, 75, 74, 73, 72, 71, 70, 72, 74, 76, 78, 80,
                    82, 84, 86, 88, 90, 88, 86, 84, 82, 80, 78, 77, 76, 75, 74, 73, 72, 71, 70, 69, 68, 67, 66, 65, 64, 63, 62, 61, 60, 62, 64, 66, 68, 70, 72, 74, 76, 78, 80, 78, 76, 74, 72, 70, 68, 66, 64, 62
                ];

                const option = {
                    grid: {
                        top: 35 * this.ratio,
                        bottom: 37 * this.ratio,
                        left: 41 * this.ratio,
                        right: 22 * this.ratio
                    },
                    dataZoom: { // 放大和缩放
                        type: 'inside'
                    },
                    tooltip: {
                        trigger: 'axis',
                        backgroundColor: 'rgba(20,30,50,0.9)',
                        textStyle: {color: '#fff'},
                        formatter: params => {
                            const t = new Date(params[0].data[0]);
                            return `${t.getHours()}:00<br/>心率: ${params[0].data[1]} bpm`
                        }
                    },
                    xAxis: {
                        type: 'category',
                        axisLine: {
                            lineStyle: {
                                color: getSkin('--line-color-2')
                            }
                        },
                        axisLabel: {
                            fontSize: 11 * this.ratio,
                            color: getSkin('--text-color-3'),
                            interval: 35,
                            fontFamily: "'D-D','SF'",
                        },
                        axisTick: {
                            show: false
                        },
                        data: ['00:00', '00:10', '00:20', '00:30', '00:40', '00:50', '01:00', '01:10', '01:20', '01:30', '01:40', '01:50', '02:00', '02:10', '02:20', '02:30', '02:40', '02:50', '03:00', '03:10', '03:20', '03:30', '03:40', '03:50', '04:00', '04:10', '04:20', '04:30', '04:40', '04:50', '05:00', '05:10', '05:20', '05:30', '05:40', '05:50', '06:00', '06:10', '06:20', '06:30', '06:40', '06:50', '07:00', '07:10', '07:20', '07:30', '07:40', '07:50', '08:00', '08:10', '08:20', '08:30', '08:40', '08:50', '09:00', '09:10', '09:20', '09:30', '09:40', '09:50', '10:00', '10:10', '10:20', '10:30', '10:40', '10:50', '11:00', '11:10', '11:20', '11:30', '11:40', '11:50', '12:00', '12:10', '12:20', '12:30', '12:40', '12:50', '13:00', '13:10', '13:20', '13:30', '13:40', '13:50', '14:00', '14:10', '14:20', '14:30', '14:40', '14:50', '15:00', '15:10', '15:20', '15:30', '15:40', '15:50', '16:00', '16:10', '16:20', '16:30', '16:40', '16:50', '17:00', '17:10', '17:20', '17:30', '17:40', '17:50', '18:00', '18:10', '18:20', '18:30', '18:40', '18:50', '19:00', '19:10', '19:20', '19:30', '19:40', '19:50', '20:00', '20:10', '20:20', '20:30', '20:40', '20:50', '21:00', '21:10', '21:20', '21:30', '21:40', '21:50', '22:00', '22:10', '22:20', '22:30', '22:40', '22:50', '23:00', '23:10', '23:20', '23:30', '23:40', '23:50', '24:00']
                    },
                    yAxis: {
                        type: 'value',
                        max: 200,
                        position: 'left',
                        splitNumber: 4,
                        interval: 50,
                        boundaryGap: [0, '10%'],
                        splitLine: {
                            lineStyle: {
                                type: 'dotted',
                                color: getSkin('--line-color-3')
                            }
                        },
                        axisLabel: {
                            fontSize: 11 * this.ratio,
                            color: getSkin('--text-color-3'),
                            showMinLabel: false,
                            fontFamily: "'D-D','SF'",
                        }
                    },
                    series: [
                        {
                            name: '心率',
                            type: 'line',
                            data: heartData,
                            smooth: true,
                            lineStyle: {color: '#ff4d6d', width: 2},
                            symbol: 'none',
                            markPoint: {
                                symbol: 'circle',
                                symbolSize: 7,
                                itemStyle: {
                                    color: '#ff4d6d',
                                    borderColor: '#fff',
                                    borderWidth: 2
                                },
                                data: [
                                    // 最大值：标签在上
                                    {
                                        type: 'max',
                                        name: 'Max',
                                        label: {
                                            show: true,
                                            position: 'top',
                                            backgroundColor: '#ff4d6d',
                                            color: '#fff',
                                            fontSize: 13 * this.ratio,
                                            padding: [4, 4, 2, 4],
                                            borderRadius: 4
                                        }
                                    },
                                    // 最小值：标签在下
                                    {
                                        type: 'min',
                                        name: 'Min',
                                        label: {
                                            show: true,
                                            position: 'bottom',
                                            backgroundColor: '#ff4d6d',
                                            color: '#fff',
                                            fontSize: 13 * this.ratio,
                                            padding: [4, 4, 2, 4],
                                            borderRadius: 4
                                        }
                                    }
                                ]
                            },
                            markArea: {
                                itemStyle: {opacity: 1},
                                data: [
                                    // 睡眠 00:00-08:00 【垂直从上到下渐变浅】
                                    [{
                                        xAxis: '00:00',
                                        itemStyle: {
                                            color: this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                                {offset: 0, color: getSkin('--text-color-52')},
                                                {offset: 1, color: getSkin('--bg-color-20')}
                                            ])
                                        }
                                    }, {xAxis: '08:00'}],
                                    // 跑步 12:00-13:00 垂直渐变
                                    [{
                                        xAxis: '12:00',
                                        itemStyle: {
                                            color: this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                                {offset: 0, color: getSkin('--text-color-52')},
                                                {offset: 1, color: getSkin('--bg-color-20')}
                                            ])
                                        }
                                    }, {xAxis: '13:00'}]
                                ]
                            }
                        },
                        // 单独放顶部图标 互不干扰
                        {
                            type: 'line',
                            data: [],
                            markPoint: {
                                symbolSize: 16 * this.ratio,
                                symbolOffset: [0, '-60%'],
                                label: {show: true, position: 'bottom', color: '#ccc', fontSize: 11},
                                data: [
                                    {
                                        name: '睡眠',
                                        xAxis: '04:00',
                                        yAxis: 200,
                                        symbol: `image://data:image/svg+xml;base64,${btoa('<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><defs><style>.a,.c{fill:none;}.a{opacity:0.16;}.b{fill:#22ACFB;}.c{stroke:#22ACFB;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}</style></defs><g transform="translate(-38 -508)"><rect class="a" width="16" height="16" transform="translate(38 508)"/><g transform="translate(40.018 509.847)"><path class="b" d="M6.153,12.306A6.153,6.153,0,0,1,6.153,0c.181,0,.363.008.542.024A5.594,5.594,0,0,0,11.188,8.95c.151,0,.3-.006.457-.019A6.129,6.129,0,0,1,6.153,12.306Z"/><path class="c" d="M47.734,514.658h3.091l-2.932,3.665h3.182" transform="translate(-39.11 -514.332)"/></g></g></svg>')}`
                                    },
                                    {
                                        name: '跑步',
                                        xAxis: '12:30',
                                        yAxis: 200,
                                        symbol: `image://data:image/svg+xml;base64,${btoa('<svg xmlns="http://www.w3.org/2000/svg" fill="#81f1b1" viewBox="0 0 24 24"><path d="M13.5 5.5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM9.8 8.9L7 23h2.1l1.8-8 2.1 2v6h2v-7.5l-2.1-2 .6-3C14.8 12 16.8 13 19 13v-2c-1.9 0-3.5-1-4.3-2.4l-1-1.6c-.4-.6-1-1-1.7-1-.3 0-.5.1-.8.1L6 8.3V13h2V9.6l1.8-.7"/></svg>')}`
                                    },
                                ]
                            }
                        }
                    ]
                };
                this.myChart.setOption(option);
            }
        },
    },
    unmounted() {
        document.removeEventListener('click', this.checkClick);
    }
}
</script>

<style scoped>
.content {
    padding-top: 96px;
}

.time-select {
    text-align: center;
    position: relative;
    font-size: 14px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 0;
}

#chart-box-pressure, #chart-box-hr {
    height: 198px;
    width: 100%;
}

.chart-unit {
    position: absolute;
    font-size: 11px;
    color: var(--text-color-3);
    left: 10px;
    top: 10px;
}

.type-select {
    display: flex;
    width: 345px;
    margin: 18px auto 0;
    justify-content: space-between;
}

.type-select div {
    display: flex;
}

.type-item {
    font-size: 11px;
    color: #9DACB7;
    padding: 2px 16px;
    border-radius: 3px;
    background-color: var(--line-color-2);
    margin-right: 12px;
}

.full-img {
    width: 18px;
    cursor: pointer;
}

.type-item.active:nth-child(1) {
    color: var(--chart-color-3);
    background-color: var(--chart-color-32);
}

.type-item.active:nth-child(2) {
    color: var(--chart-color-8);
    background-color: var(--chart-color-82);
}

.avg-box {
    width: 108px;
    height: 62px;
    border-radius: 13px 13px 13px 13px;
    padding-left: 13px;
}

.math-title {
    font-size: 13px;
    color: var(--text-color-2);
    padding-top: 10px;
}

.math-value {
    font-size: 24px;
    color: var(--text-color-1);
    line-height: 24px;
}

.math-unit {
    font-size: 13px;
    margin-left: 4px;
}

.data-box {
    width: 345px;
    margin: 0 auto;
    display: flex;
}

.rang-box {
    width: 197px;
    margin-left: 12px;
}

.chart-out {
    position: relative;
}

/* 全屏样式 */
.fullscreen-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.9);
    z-index: 9999;
    display: flex;
    justify-content: center;
    align-items: center;
}

.fullscreen-chart {
    width: 90%;
    height: 90%;
    background: var(--bg-color-1);
    border-radius: 10px;
    padding: 20px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
}

.fullscreen-header {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
}

.exit-fullscreen-icon {
    width: 12px;
    height: 12px;
    margin-right: 15px;
    cursor: pointer;
}

.chart-title {
    font-size: 10px;
    color: var(--text-color-1);
    font-weight: bold;
}

#fullscreen-chart-box {
    flex: 1;
    width: 100%;
    height: calc(100% - 60px);
}

#y-axis-lines {
    position: absolute;
    left: 41px;
    top: 35px;
    width: 2px;
    bottom: 37px;
}

.time-box {
    margin-bottom: 14px;
}

.line-box {
    width: 345px;
    height: 106px;
    background: var(--bg-color-2);
    border-radius: 13px 13px 13px 13px;
    margin-left: 15px;
    position: relative;
    border: 1px solid var(--bg-color-2);
    margin-bottom: 8px;
}

.line-box-active {
    border: 1px solid #FFFFFF;
}

.line-img {
    width: 20px;
    position: absolute;
    top: 18px;
    left: 16px;
}

.line-time {
    font-size: 11px;
    color: var(--text-color-2);
    position: absolute;
    top: 12px;
    left: 42px;
}

.line-type {
    font-size: 15px;
    position: absolute;
    top: 28px;
    left: 42px;
}

.line-value-box {
    position: absolute;
    top: 24px;
    right: 16px;
    font-size: 20px;
}

.line-unit {
    font-size: 11px;
    margin-left: 4px;
}

.line-split {
    width: 287px;
    height: 1px;
    background-color: var(--text-color-22);
    position: absolute;
    top: 54px;
    left: 42px;
}

.line-hr-title1 {
    font-size: 11px;
    color: var(--text-color-3);
    position: absolute;
    top: 62px;
    left: 42px;
}

.line-hr-title2 {
    font-size: 11px;
    color: var(--text-color-3);
    position: absolute;
    top: 62px;
    left: 154px;
}

.line-hr-value1 {
    font-size: 15px;
    position: absolute;
    top: 77px;
    left: 42px;
}

.line-hr-value2 {
    font-size: 15px;
    position: absolute;
    top: 77px;
    left: 154px;
}
</style>



// WEBPACK FOOTER //
// src/views/status/28timeLine.vue